import React, { forwardRef, useCallback, useEffect, useRef } from 'react';

let emptySrc;

export const IframeWrapper = forwardRef((props, outerRef) => {
    const { isHeaderParamsEnabled = false, headers, documentForwardProps, baseHref, src, title, ...rest } = props;

    const innerRef = useRef();
    const ref = outerRef ?? innerRef;

    const fetchPage = useCallback(async () => {
        if (!isHeaderParamsEnabled) {
            return;
        }
        try {
            if (!!ref.current?.contentDocument?.FORWARDED_SRC) {
                return;
            }

            const response = await fetch(src, { headers, responseType: 'document' });

            let parsedResponse = await response.text();

            if (baseHref) {
                parsedResponse = parsedResponse.replace('<head>', `<head><base href="${baseHref}" />`);
            }

            const iframeEl = ref.current;
            if (!iframeEl || !!iframeEl?.contentDocument?.FORWARDED_SRC) {
                return;
            }

            if (documentForwardProps) {
                iframeEl.contentDocument.PARENT_FORWARDED_PROPS = documentForwardProps;
            }
            iframeEl.contentDocument.FORWARDED_SRC = src;

            iframeEl.contentDocument.open();
            iframeEl.contentDocument.write(parsedResponse);
            iframeEl.contentDocument.close();
        } catch (error) {
            console.error('Iframe wrapper error', error);
        }
        // We need to load iframe only if new src received or enabled/disabled
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [src, isHeaderParamsEnabled]);

    useEffect(() => {
        fetchPage();
    }, [fetchPage]);

    return (
        <iframe
            key={isHeaderParamsEnabled ? src : undefined}
            src={isHeaderParamsEnabled ? emptySrc : src}
            title={title}
            ref={ref}
            {...rest}
        />
    );
});
